import React from "react";
import "./styles/base-layer.css";
import ReactDOM from "react-dom/client";
// import { App } from "./App";
import reportWebVitals from "./reportWebVitals";

import { ToastProvider } from "components/ToastProvider/ToastProvider";
import { PConfirmPopup } from "@prime/PConfirmPopup/PConfirmPopup";
import { PConfirmDialog } from "@prime/PConfirmDialog/PConfirmDialog";
import App from "App";
import { getSentryService } from "services/sentry.service";
import retryingDynamicImport from "retrying-dynamic-import";

// Registers window.__retrying_dynamic_loader__, which the build-time plugin
// (vite-plugins/retryDynamicImport.js) routes every static-specifier dynamic
// import through. Retries failed JS/CSS chunk loads (Sentry: IDEALLY-REACT-67R).
retryingDynamicImport();

getSentryService().init();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
    <ToastProvider />
    <PConfirmPopup />
    <PConfirmDialog />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app pass a function
// or send to an analytics endpoint. Learn more:  https://bit.ly/CRA-vitals

reportWebVitals();
